import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractHttpService } from "./http-abstract-service";
import { SubmitData } from "../dto";
import { Config as FacetecConfig } from "src/assets/Config";

@Injectable({
    providedIn: "root",
})
export class HttpFacetecService extends AbstractHttpService {
    constructor(http: HttpClient) {
        super(http, "/api/capture");
    }

    public start(ref: string) {
        const path = `/${ref}/start`;
		return super.post(path, null);
    }

    public submit(ref: String, data: SubmitData) {
        const path = `/${FacetecConfig.transactionId}/${ref}`;
        return super.post(path, data);
    }
}
